import { settings } from './storage.js';

/* Shells: pieles completas de la interfaz, por encima del tema (oscuro/claro) y del color de acento.

   Un shell es un paquete de VALORES, no de código: las variables de diseño de tokens.css (colores, tipografía, radios,
   densidad, sombras) y unos pocos interruptores de forma (carátulas cuadradas, con marco, sin sombras, densidad alta,
   títulos en mayúsculas), que son clases en <html> con sus reglas en components.css. Así la interfaz puede dejar de
   parecer «un Netflix» sin tocar ninguna pantalla, y los shells se pueden describir en un JSON y traer de fuera.

   «cine» es el aspecto original y no define nada: todo viene de :root (y del tema claro si se elige). */

export const FLAGS = ['square', 'framed', 'flat', 'dense', 'caps'];

/* Ejes de disposición (clases layout-<eje>-<valor> en <html>, reglas en www/css/layouts.css). El primer valor de cada eje es
   el de siempre y no pone clase. */
export const LAYOUT = {
    nav: ['top', 'side', 'bottom', 'dock'],
    cards: ['poster', 'wide', 'square', 'circle'],
    hero: ['full', 'split', 'band', 'none'],
    rows: ['carousel', 'grid'],
    ground: ['plain', 'grain', 'lines', 'glow', 'dots', 'grid', 'scan', 'stage'],
    motion: ['normal', 'still', 'lively'],
    detail: ['cover', 'split', 'band'],
    enter: ['none', 'rise', 'fade', 'slide', 'zoom']
};

/** Variables que un shell puede fijar (y nada más: lo que no está aquí se ignora al importar). */
export const VARS = [
    'bg', 'bg-elev', 'surface', 'surface-2', 'surface-hover', 'border', 'text', 'text-2', 'text-3',
    'accent', 'accent-hover', 'accent-soft', 'success', 'warning', 'danger', 'live', 'focus', 'focus-ring', 'overlay', 'overlay-strong',
    'fg-rgb', 'bg-rgb', 'on-text', 'poster-a', 'poster-b',
    'font', 'fs-xs', 'fs-sm', 'fs-md', 'fs-lg', 'fs-xl', 'fs-2xl',
    'radius-sm', 'radius', 'radius-lg', 'radius-pill',
    'font-display', 'card-w', 'card-w-wide', 'card-w-channel', 'gutter', 'shadow', 'shadow-lg', 'dur',
    'on-media', 'media-fg-rgb', 'scrim-rgb', 'media-bg', 'media-bg-soft', 'on-accent', 'glass-rgb', 'focus-strong', 'paper', 'ink', 'ink-strong',
    'ok', 'ok-bright', 'ok-text', 'warn', 'warn-strong', 'warn-amber', 'danger-text', 'danger-soft', 'rec', 'kind-vod', 'kind-series',
    'player-panel', 'player-chip', 'player-chip-soft', 'player-chip-hover', 'player-ghost', 'player-ghost-focus', 'ps-card', 'ps-card-soft'
];

export const SHELLS = [
    { id: 'cine', base: 'auto', vars: {}, flags: [] },
    {
        id: 'papel', base: 'light', flags: ['framed'],
        vars: {
            bg: '#f1e8d6', 'bg-elev': '#f8f1e3', surface: '#fbf6ec', 'surface-2': '#eadfc8', 'surface-hover': '#e0d3b6',
            border: 'rgba(70, 48, 18, 0.18)', text: '#2b2117', 'text-2': '#6b5a46', 'text-3': '#85755f',
            accent: '#8c2f1b', 'accent-hover': '#a53a22', 'accent-soft': 'rgba(140, 47, 27, 0.16)', live: '#8c2f1b', danger: '#8c2f1b',
            focus: '#2b2117', 'focus-ring': '0 0 0 2px rgba(43, 33, 23, 0.35)', 'fg-rgb': '43, 33, 23', 'bg-rgb': '241, 232, 214', 'on-text': '#fff',
            'poster-a': '#e6dcc6', 'poster-b': '#d8ccb2',
            font: 'Georgia, "Times New Roman", "Noto Serif", serif',
            'radius-sm': '2px', radius: '3px', 'radius-lg': '6px',
            shadow: '0 2px 10px rgba(60, 40, 10, 0.18)', 'shadow-lg': '0 12px 40px rgba(60, 40, 10, 0.22)'
        }
    },
    {
        id: 'terminal', base: 'dark', flags: ['flat', 'dense', 'caps'],
        vars: {
            bg: '#070a07', 'bg-elev': '#0c110c', surface: '#0f160f', 'surface-2': '#162016', 'surface-hover': '#1f2d1f',
            border: 'rgba(120, 255, 120, 0.22)', text: '#d9f7d9', 'text-2': '#8fc98f', 'text-3': '#5f8f5f',
            accent: '#39ff14', 'accent-hover': '#7dff5e', 'accent-soft': 'rgba(57, 255, 20, 0.14)', live: '#39ff14', success: '#39ff14',
            focus: '#39ff14', 'focus-ring': '0 0 0 2px rgba(57, 255, 20, 0.6)', 'on-text': '#041004', 'poster-a': '#101810', 'poster-b': '#0a100a',
            font: 'ui-monospace, "Roboto Mono", "Droid Sans Mono", Menlo, Consolas, monospace',
            'fs-md': '0.95rem', 'fs-lg': '1.15rem', 'fs-xl': '1.5rem', 'fs-2xl': '2rem',
            'radius-sm': '0px', radius: '0px', 'radius-lg': '0px', 'radius-pill': '0px',
            shadow: 'none', 'shadow-lg': 'none', dur: '0ms'
        }
    },
    {
        id: 'pastel', base: 'light', flags: ['square'],
        vars: {
            bg: '#faf7ff', 'bg-elev': '#ffffff', surface: '#ffffff', 'surface-2': '#efe8ff', 'surface-hover': '#e4d9ff',
            border: 'rgba(90, 60, 160, 0.14)', text: '#2d2440', 'text-2': '#6e6386', 'text-3': '#8b81a3',
            accent: '#7c5cff', 'accent-hover': '#9177ff', 'accent-soft': 'rgba(124, 92, 255, 0.16)', live: '#ff6b9d', danger: '#ff5c7a', success: '#3ec98a', warning: '#ffb020',
            focus: '#7c5cff', 'focus-ring': '0 0 0 3px rgba(124, 92, 255, 0.35)', 'fg-rgb': '45, 36, 64', 'bg-rgb': '250, 247, 255', 'on-text': '#fff',
            'poster-a': '#ece4ff', 'poster-b': '#dfd3ff',
            'radius-sm': '10px', radius: '18px', 'radius-lg': '26px',
            'card-w': '140px', 'card-w-channel': '140px',
            shadow: '0 10px 30px rgba(124, 92, 255, 0.14)', 'shadow-lg': '0 24px 60px rgba(124, 92, 255, 0.2)'
        }
    },
    {
        /* Quiosco: una revista. Papel crema, titulares con serifa, menú en un carril lateral y carátulas apaisadas con marco. */
        id: 'quiosco', base: 'light', flags: ['framed'], layout: { nav: 'side', cards: 'wide', detail: 'split', enter: 'rise' },
        vars: {
            bg: '#f5f0e6', 'bg-elev': '#faf6ee', surface: '#fffdf8', 'surface-2': '#ece5d6', 'surface-hover': '#e3dac7',
            border: 'rgba(40, 30, 20, 0.16)', text: '#1d1a16', 'text-2': '#5f574c', 'text-3': '#827868',
            accent: '#c8102e', 'accent-hover': '#e0213f', 'accent-soft': 'rgba(200, 16, 46, 0.14)', live: '#c8102e', danger: '#c8102e', success: '#1f7a3d', warning: '#b7791f',
            focus: '#1d1a16', 'focus-ring': '0 0 0 2px rgba(29, 26, 22, 0.4)', 'fg-rgb': '29, 26, 22', 'bg-rgb': '245, 240, 230', 'on-text': '#fff',
            paper: '#fffdf8', ink: '#1d1a16', 'poster-a': '#e8e1d2', 'poster-b': '#ddd4c2',
            'font-display': 'Georgia, "Times New Roman", "Noto Serif", serif',
            'fs-xl': '1.9rem', 'fs-2xl': '2.8rem',
            'radius-sm': '2px', radius: '4px', 'radius-lg': '8px',
            shadow: '0 1px 0 rgba(40, 30, 20, 0.08), 0 8px 24px rgba(40, 30, 20, 0.12)', 'shadow-lg': '0 16px 48px rgba(40, 30, 20, 0.18)'
        }
    },
    {
        /* Quiosco noche: la misma revista, impresa en negro. Tinta cálida casi negra, papel crema para el texto, mismo carril lateral y carátulas apaisadas con marco. */
        id: 'quiosco-noche', base: 'dark', flags: ['framed'], layout: { nav: 'side', cards: 'wide', detail: 'split', enter: 'rise' },
        vars: {
            bg: '#15120f', 'bg-elev': '#1c1814', surface: '#231e19', 'surface-2': '#2d2720', 'surface-hover': '#3a322a',
            border: 'rgba(245, 235, 215, 0.16)', text: '#f4ecdc', 'text-2': '#b7ab98', 'text-3': '#7d7364',
            accent: '#e0314b', 'accent-hover': '#f04b63', 'accent-soft': 'rgba(224, 49, 75, 0.2)', live: '#e0314b', danger: '#e0314b', success: '#6ab87f', warning: '#e0a43a',
            focus: '#f4ecdc', 'focus-ring': '0 0 0 2px rgba(244, 236, 220, 0.55)', 'fg-rgb': '244, 236, 220', 'bg-rgb': '21, 18, 15', 'on-text': '#15120f', 'on-accent': '#fff',
            'glass-rgb': '244, 236, 220', paper: '#f4ecdc', ink: '#15120f', 'poster-a': '#2a241d', 'poster-b': '#1f1a15',
            'font-display': 'Georgia, "Times New Roman", "Noto Serif", serif',
            'fs-xl': '1.9rem', 'fs-2xl': '2.8rem',
            'radius-sm': '2px', radius: '4px', 'radius-lg': '8px',
            shadow: '0 1px 0 rgba(0, 0, 0, 0.4), 0 10px 28px rgba(0, 0, 0, 0.5)', 'shadow-lg': '0 18px 54px rgba(0, 0, 0, 0.65)'
        }
    },
    {
        /* Consola: una consola de juegos. Grafito casi negro y verde ácido, dock flotante, cabecera partida y carátulas apaisadas con rebote. */
        id: 'consola', base: 'dark', flags: [], layout: { nav: 'dock', cards: 'wide', hero: 'split', ground: 'scan', motion: 'lively', detail: 'split', enter: 'slide' },
        vars: {
            bg: '#0b0c0e', 'bg-elev': '#121417', surface: '#171a1e', 'surface-2': '#20242a', 'surface-hover': '#2a2f37',
            border: 'rgba(198, 255, 61, 0.14)', text: '#f2f5ee', 'text-2': '#a9b09f', 'text-3': '#6f766a',
            accent: '#c6ff3d', 'accent-hover': '#d6ff6b', 'accent-soft': 'rgba(198, 255, 61, 0.13)', live: '#ff4d6d', success: '#c6ff3d', warning: '#ffd23d', danger: '#ff4d6d',
            focus: '#c6ff3d', 'focus-ring': '0 0 0 2px rgba(198, 255, 61, 0.7), 0 0 26px rgba(198, 255, 61, 0.28)', 'on-text': '#0b0c0e', 'on-accent': '#0b0c0e',
            'poster-a': '#1b1f24', 'poster-b': '#121417',
            font: '"sans-serif-medium", "Segoe UI Semibold", "Helvetica Neue", Arial, sans-serif', 'font-display': '"sans-serif-condensed", "Arial Narrow", "Roboto Condensed", Arial, sans-serif',
            'radius-sm': '8px', radius: '14px', 'radius-lg': '22px',
            shadow: '0 10px 30px rgba(0, 0, 0, 0.55)', 'shadow-lg': '0 24px 70px rgba(0, 0, 0, 0.7)'
        }
    },
    {
        /* Mosaico: una galería. Berenjena y mandarina, sin cabecera, filas en cuadrícula y carátulas cuadradas muy redondeadas. */
        id: 'mosaico', base: 'dark', flags: [], layout: { cards: 'square', hero: 'none', rows: 'grid', ground: 'dots', detail: 'band', enter: 'zoom' },
        vars: {
            bg: '#1a1423', 'bg-elev': '#221a2d', surface: '#2a2137', 'surface-2': '#362b46', 'surface-hover': '#43365a',
            border: 'rgba(255, 190, 140, 0.16)', text: '#fff3ea', 'text-2': '#d5bfae', 'text-3': '#9a8576',
            accent: '#ff8a3d', 'accent-hover': '#ffa066', 'accent-soft': 'rgba(255, 138, 61, 0.17)', live: '#ff5c8a', success: '#7be0a0', warning: '#ffcf5c', danger: '#ff5c8a',
            focus: '#ffb98a', 'focus-ring': '0 0 0 3px rgba(255, 138, 61, 0.6)', 'on-text': '#2b1500', 'on-accent': '#2b1500', 'poster-a': '#2f2540', 'poster-b': '#241b32',
            font: 'ui-rounded, "SF Pro Rounded", "Nunito", "Trebuchet MS", "Segoe UI", sans-serif',
            'radius-sm': '12px', radius: '20px', 'radius-lg': '28px',
            shadow: '0 8px 0 rgba(0, 0, 0, 0.22)', 'shadow-lg': '0 16px 0 rgba(0, 0, 0, 0.26)'
        }
    },
    {
        /* Catálogo: una ficha de biblioteca. Gris laboratorio, tinta y verde botella, letra de máquina, banda baja y renglones. */
        id: 'catalogo', base: 'light', flags: ['framed', 'caps'], layout: { nav: 'bottom', hero: 'band', ground: 'grid', motion: 'still', detail: 'band' },
        vars: {
            bg: '#eef0ed', 'bg-elev': '#f6f7f4', surface: '#fbfcfa', 'surface-2': '#e3e7e1', 'surface-hover': '#d6dcd3',
            border: 'rgba(20, 40, 30, 0.2)', text: '#14201a', 'text-2': '#4d5e54', 'text-3': '#66766b',
            accent: '#0f6b4f', 'accent-hover': '#14835f', 'accent-soft': 'rgba(15, 107, 79, 0.14)', live: '#b3261e', success: '#0f6b4f', warning: '#9a6700', danger: '#b3261e',
            focus: '#14201a', 'focus-ring': '0 0 0 2px rgba(20, 32, 26, 0.55)', 'fg-rgb': '20, 32, 26', 'bg-rgb': '238, 240, 237', 'on-text': '#fff', 'on-accent': '#fff',
            paper: '#fbfcfa', ink: '#14201a', 'poster-a': '#dfe4dc', 'poster-b': '#d1d8cd',
            font: 'ui-monospace, "Roboto Mono", "Droid Sans Mono", Menlo, Consolas, monospace', 'font-display': 'ui-monospace, "Roboto Mono", "Droid Sans Mono", Menlo, Consolas, monospace',
            'fs-md': '0.95rem', 'fs-lg': '1.15rem',
            'radius-sm': '0px', radius: '2px', 'radius-lg': '4px',
            shadow: 'none', 'shadow-lg': '0 12px 36px rgba(20, 32, 26, 0.18)'
        }
    },
    {
        /* Aurora: noche con luces. Violeta profundo con resplandores rosas, canales y carátulas redondeadas y entrada con rebote. */
        id: 'aurora', base: 'dark', flags: [], layout: { cards: 'circle', ground: 'glow', motion: 'lively', enter: 'fade' },
        vars: {
            bg: '#0a0817', 'bg-elev': '#110d24', surface: '#171231', 'surface-2': '#221a45', 'surface-hover': '#2e2459',
            border: 'rgba(190, 150, 255, 0.18)', text: '#f4efff', 'text-2': '#b9aedb', 'text-3': '#7d72a3',
            accent: '#c77dff', 'accent-hover': '#d79bff', 'accent-soft': 'rgba(199, 125, 255, 0.2)', live: '#ff5ea8', success: '#5eead4', warning: '#fbbf24', danger: '#ff5ea8',
            focus: '#e0b3ff', 'focus-ring': '0 0 0 2px rgba(199, 125, 255, 0.7), 0 0 30px rgba(255, 94, 168, 0.28)', 'on-text': '#16062b', 'on-accent': '#16062b', 'poster-a': '#1c1540', 'poster-b': '#120d2c',
            font: 'ui-rounded, "SF Pro Rounded", "Nunito", "Segoe UI", sans-serif',
            'radius-sm': '10px', radius: '18px', 'radius-lg': '30px',
            shadow: '0 12px 36px rgba(60, 20, 120, 0.4)', 'shadow-lg': '0 30px 80px rgba(60, 20, 120, 0.55)'
        }
    },
    {
        /* Noir: cine negro. Blanco y negro con plata, sin un solo color, titulares con serifa fina, cabecera en banda, ficha con la imagen arriba, grano de película y entrada que aparece como un fundido. */
        id: 'noir', base: 'dark', flags: ['framed'], layout: { hero: 'band', ground: 'grain', detail: 'band', enter: 'fade' },
        vars: {
            bg: '#080808', 'bg-elev': '#101010', surface: '#161616', 'surface-2': '#202020', 'surface-hover': '#2b2b2b',
            border: 'rgba(235, 235, 235, 0.16)', text: '#ececec', 'text-2': '#a6a6a6', 'text-3': '#6b6b6b',
            accent: '#e9e9e9', 'accent-hover': '#ffffff', 'accent-soft': 'rgba(233, 233, 233, 0.14)', live: '#d4202a', success: '#bdbdbd', warning: '#cfcfcf', danger: '#d4202a',
            focus: '#ffffff', 'focus-ring': '0 0 0 2px rgba(255, 255, 255, 0.65)', 'on-text': '#080808', 'on-accent': '#080808', 'poster-a': '#1b1b1b', 'poster-b': '#111111',
            'font-display': 'Didot, "Bodoni MT", "Playfair Display", "Noto Serif Display", Georgia, serif',
            'fs-xl': '1.9rem', 'fs-2xl': '2.8rem',
            'radius-sm': '2px', radius: '3px', 'radius-lg': '6px',
            shadow: '0 12px 34px rgba(0, 0, 0, 0.7)', 'shadow-lg': '0 28px 72px rgba(0, 0, 0, 0.85)'
        }
    },
    {
        /* Escenario: un teatro a oscuras. La carátula que tiene el foco (o el ratón) «enciende» el fondo de toda la pantalla con su propia
           imagen desenfocada y atenúa al resto de su fila, como un foco de sala; latón sobre negro cálido, titulares con serifa, botones en
           píldora y pequeñas luces de escena delante de cada sección. El fondo cambia con lo que miras: no hay dos pantallas iguales. */
        id: 'escenario', base: 'dark', flags: [], layout: { hero: 'split', ground: 'stage', enter: 'fade' },
        vars: {
            bg: '#07090b', 'bg-elev': '#0c1013', surface: '#121719', 'surface-2': '#1a2124', 'surface-hover': '#232c30',
            border: 'rgba(231, 194, 122, 0.16)', text: '#f3ede2', 'text-2': '#b8b0a2', 'text-3': '#7c766c',
            accent: '#e7c27a', 'accent-hover': '#f2d394', 'accent-soft': 'rgba(231, 194, 122, 0.18)', live: '#ff6a5c', success: '#8fd4a8', warning: '#e7c27a', danger: '#ff6a5c',
            focus: '#fff2cc', 'focus-ring': '0 0 0 2px rgba(231, 194, 122, 0.85), 0 0 40px rgba(231, 194, 122, 0.35)', 'on-text': '#1a1407', 'on-accent': '#1a1407', 'poster-a': '#161b1e', 'poster-b': '#0d1114',
            'font-display': '"Iowan Old Style", "Palatino Linotype", Palatino, "Noto Serif", Georgia, serif',
            'fs-xl': '2rem', 'fs-2xl': '3rem',
            'radius-sm': '6px', radius: '12px', 'radius-lg': '22px', 'radius-pill': '999px',
            shadow: '0 18px 50px rgba(0, 0, 0, 0.6)', 'shadow-lg': '0 40px 100px rgba(0, 0, 0, 0.75)'
        }
    },
    {
        /* Escenario de día: la sesión de tarde. El mismo foco de sala, pero sobre papel marfil: lo que miras tiñe el fondo con su propia imagen
           como una acuarela y el resto de la fila se apaga; bronce en vez de latón, tinta cálida y titulares con serifa. */
        id: 'escenario-dia', base: 'light', flags: [], layout: { hero: 'split', ground: 'stage', enter: 'fade' },
        vars: {
            bg: '#f7f2e8', 'bg-elev': '#fbf8f1', surface: '#fffdf8', 'surface-2': '#efe8d8', 'surface-hover': '#e6dcc7',
            border: 'rgba(110, 80, 30, 0.2)', text: '#1d1a14', 'text-2': '#5d5546', 'text-3': '#82796a',
            accent: '#a06a14', 'accent-hover': '#b97b1a', 'accent-soft': 'rgba(160, 106, 20, 0.16)', live: '#c2412d', danger: '#c2412d', success: '#2f7d4f', warning: '#a06a14',
            focus: '#1d1a14', 'focus-ring': '0 0 0 2px rgba(160, 106, 20, 0.85), 0 0 30px rgba(160, 106, 20, 0.25)', 'fg-rgb': '29, 26, 20', 'bg-rgb': '247, 242, 232',
            'on-text': '#fffaf0', 'on-accent': '#fffaf0', paper: '#fffdf8', ink: '#1d1a14', 'poster-a': '#e9e1cf', 'poster-b': '#ddd3bd',
            'font-display': '"Iowan Old Style", "Palatino Linotype", Palatino, "Noto Serif", Georgia, serif',
            'fs-xl': '2rem', 'fs-2xl': '3rem',
            'radius-sm': '6px', radius: '12px', 'radius-lg': '22px', 'radius-pill': '999px',
            shadow: '0 14px 38px rgba(90, 60, 15, 0.16)', 'shadow-lg': '0 30px 80px rgba(90, 60, 15, 0.24)'
        }
    },
    {
        id: 'retro', base: 'dark', flags: ['caps'],
        vars: {
            bg: '#0a1b36', 'bg-elev': '#0f2446', surface: '#14305a', 'surface-2': '#1b3d6f', 'surface-hover': '#244c86',
            border: 'rgba(255, 220, 120, 0.18)', text: '#fdf6d8', 'text-2': '#cbc3a3', 'text-3': '#8f8a72',
            accent: '#ffb000', 'accent-hover': '#ffc53d', 'accent-soft': 'rgba(255, 176, 0, 0.18)', live: '#ff4d4d', warning: '#ffb000',
            focus: '#ffb000', 'focus-ring': '0 0 0 3px rgba(255, 176, 0, 0.55)', 'on-text': '#1a1200', 'poster-a': '#12294d', 'poster-b': '#0c1e3a',
            font: '"sans-serif-condensed", "Arial Narrow", "Roboto Condensed", Arial, sans-serif',
            'fs-md': '1.06rem', 'fs-lg': '1.35rem', 'fs-xl': '1.9rem', 'fs-2xl': '2.7rem',
            'radius-sm': '2px', radius: '4px', 'radius-lg': '6px',
            shadow: '0 6px 0 rgba(0, 0, 0, 0.35)', 'shadow-lg': '0 12px 0 rgba(0, 0, 0, 0.4)'
        }
    }
];

const SLUG = /^[a-z0-9][a-z0-9-]{1,30}$/;
// Valores de CSS permitidos: colores, números con unidad, familias de letra, sombras… Nada que abra paréntesis raros,
// ni url(), ni expresiones, ni cierres de bloque: un shell importado no puede colar CSS arbitrario.
const SAFE_VALUE = /^[\w\s#%,.()\/+\-"'!]{1,160}$/;
const FORBIDDEN = /url\s*\(|expression|javascript|@import|[;{}<>\\]/i;

/** Comprueba y limpia un shell que viene de fuera (JSON). Devuelve el shell válido o lanza Error('invalid_shell'). */
export function sanitizeShell(input) {
    const fail = () => { throw Object.assign(new Error('invalid_shell'), { code: 'invalid_shell' }); };
    if (!input || typeof input !== 'object') fail();
    const id = String(input.id || '').trim().toLowerCase();
    if (!SLUG.test(id) || SHELLS.some((s) => s.id === id)) fail();
    const name = String(input.name || id).trim().slice(0, 40);
    const base = ['dark', 'light', 'auto'].indexOf(input.base) !== -1 ? input.base : 'dark';
    const vars = {};
    Object.keys(input.vars || {}).forEach((k) => {
        const key = String(k).replace(/^--/, '');
        const v = String(input.vars[k] == null ? '' : input.vars[k]).trim();
        if (VARS.indexOf(key) === -1 || !SAFE_VALUE.test(v) || FORBIDDEN.test(v)) return;
        vars[key] = v;
    });
    const flags = Array.isArray(input.flags) ? input.flags.map(String).filter((f) => FLAGS.indexOf(f) !== -1) : [];
    const layout = sanitizeLayout(input.layout);
    if (!Object.keys(vars).length && !flags.length && !Object.keys(layout).length) fail();
    return { id, name, base, vars, flags, layout, custom: true };
}

/** La disposición de un shell: solo ejes y valores conocidos; el valor de siempre no se guarda. */
export function sanitizeLayout(input) {
    const out = {};
    Object.keys(LAYOUT).forEach((axis) => {
        const v = input && input[axis] != null ? String(input[axis]) : '';
        if (LAYOUT[axis].indexOf(v) > 0) out[axis] = v;
    });
    return out;
}

/** Clases layout-* que pone un shell en <html>. */
export function layoutClasses(shell) {
    const l = sanitizeLayout(shell && shell.layout);
    return Object.keys(l).map((axis) => 'layout-' + axis + '-' + l[axis]);
}

export function customShells() {
    const list = settings.get('customShells');
    return Array.isArray(list) ? list : [];
}

export function allShells() {
    return SHELLS.concat(customShells());
}

export function shellById(id) {
    return allShells().find((s) => s.id === id) || SHELLS[0];
}

export function addCustomShell(input) {
    const shell = sanitizeShell(input);
    const list = customShells().filter((s) => s.id !== shell.id).concat([shell]).slice(-12);
    settings.set('customShells', list);
    return shell;
}

export function removeCustomShell(id) {
    settings.set('customShells', customShells().filter((s) => s.id !== id));
    if (settings.get('shell') === id) settings.set('shell', 'cine');
}

/** El shell actual como JSON exportable (para compartirlo o retocarlo). */
export function exportShell(shell) {
    return JSON.stringify({ id: shell.custom ? shell.id : shell.id + '-copia', name: shell.name || shell.id, base: shell.base, vars: shell.vars, flags: shell.flags, layout: sanitizeLayout(shell.layout) }, null, 2);
}

const hexToRgb = (hex) => {
    const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return null;
    let h = m[1];
    if (h.length === 3) h = h.split('').map((c) => c + c).join('');
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

/**
 * Aplica un shell al documento: base clara u oscura, variables en línea y clases de forma. `themeMode` es el ajuste
 * oscuro/claro/auto, que solo manda en «cine» (los demás traen su base). Devuelve si la base resultante es clara.
 */
export function applyShell(shell, { themeMode = 'dark', systemDark = true, accentOverride = null, doc = document } = {}) {
    const html = doc.documentElement;
    const prev = html.getAttribute('data-shell');
    // Fuera lo del shell anterior: sus variables en línea y sus clases.
    VARS.forEach((v) => html.style.removeProperty('--' + v));
    ['--f7-theme-color-rgb', '--f7-theme-color-shade', '--f7-theme-color-tint'].forEach((v) => html.style.removeProperty(v));
    FLAGS.forEach((f) => html.classList.remove('shell-' + f));
    Object.keys(LAYOUT).forEach((axis) => LAYOUT[axis].forEach((v) => html.classList.remove('layout-' + axis + '-' + v)));
    if (prev) html.removeAttribute('data-shell');

    const base = shell.base === 'auto' ? themeMode : shell.base;
    const light = base === 'light' || (base === 'auto' && !systemDark);
    if (light) html.setAttribute('data-theme', 'light'); else html.removeAttribute('data-theme');
    html.classList.toggle('dark', !light);
    html.style.colorScheme = light ? 'light' : 'dark';

    if (shell.id !== 'cine') html.setAttribute('data-shell', shell.id);
    const vars = Object.assign({}, shell.vars || {});
    if (accentOverride) {
        vars.accent = accentOverride;
        delete vars['accent-hover'];
        delete vars['accent-soft'];
        const rgb = hexToRgb(accentOverride);
        if (rgb) vars['accent-soft'] = 'rgba(' + rgb.join(', ') + ', 0.18)';
    }
    Object.keys(vars).forEach((k) => html.style.setProperty('--' + k, vars[k]));
    // Framework7 pinta algunos controles con su propio color de tema: se le da el acento del shell.
    const rgb = hexToRgb(vars.accent);
    if (rgb) {
        html.style.setProperty('--f7-theme-color-rgb', rgb.join(', '));
        html.style.setProperty('--f7-theme-color-shade', 'rgb(' + rgb.map((c) => Math.max(0, Math.round(c * 0.8))).join(', ') + ')');
        html.style.setProperty('--f7-theme-color-tint', 'rgb(' + rgb.map((c) => Math.min(255, Math.round(c + (255 - c) * 0.25))).join(', ') + ')');
    }
    (shell.flags || []).forEach((f) => html.classList.add('shell-' + f));
    layoutClasses(shell).forEach((c) => html.classList.add(c));
    const meta = doc.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', vars.bg || (light ? '#f4f4f6' : '#141414'));
    return light;
}
